import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import documentApi from "../api/document";
import { sendError } from "../errors";
import { humanFileSize } from "../helpers.js";
import i18n from "../i18n";

export const fetchAll = createAsyncThunk(
  "documents/fetchAllStatus",
  async () => {
    try {
      return await documentApi.all();
    } catch (err) {
      sendError(err);
    }
  }
);

export const documentsSlice = createSlice({
  name: "hints",
  initialState: {
    loading: false,
    taskFiles: [],
    userFiles: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchAll.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchAll.fulfilled, (state, action) => {
      state.loading = false;
      state.taskFiles = action.payload.taskFiles.map((info) => ({
        size: humanFileSize(info.fileSize),
        src: info.downloadUrl,
        thumbnail: info.thumbUrl || "/images/file-placeholder.svg",
        title: i18n.t(`documents.${info.id}.title`),
        taskIds: info.taskIds,
      }));
      state.userFiles = action.payload.userFiles.map((info) => ({
        fileId: info.fileId,
        size: humanFileSize(info.fileSize),
        src: info.urls.original,
        thumbnail:
          info.urls?.avatar256 ||
          info.thumbUrl ||
          "/images/file-placeholder.svg",
        title: info.originalFileName,
        taskIds: info.taskIds,
      }));
    });
    builder.addCase(fetchAll.rejected, (state) => {
      // TODO: Log error
      state.loading = false;
    });
  },
});

export default documentsSlice.reducer;
